/* THIS IS ROUTING PAGE CONTROL . DONT DO ANYTHING ELSE*/

import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import ScrollToTop from "./ScrollToTop"   // ✅ import it here
import Header from "./components/Header" 
import Login from "./pages/login.js"
import FleetPage from "./fleetpage.js" 
import Footer from "./components/Footer"
import Aboutus from "./pages/Aboutus"
import WhyUs from "./pages/WhyUs.js" 
import Privatepilot from "./pages/Privatepilot.js" 
import FlightInstructor from "./pages/FlightInstructor.js" 
import Typerating from "./pages/Typerating.js" 
import Cabincrew from "./pages/Cabincrew.js" 
import NotFoundPage from "./pages/static/NotFoundPage"
import "./App.css"
import HomePage from "./pages/static/home_page/HomePage.js"
import ContactUs from "./pages/ContactUs.js"
import CourseListingTemplate from "./templates/CourseListingTemplate.js"
import WebinarPage from "./pages/WebinarPage.js"
import CourseTemplate from "./templates/CourseTemplate.js"
import ClassTemplate from "./templates/ClassTemplate.js"
import SchoolListingTemplate from "./templates/SchoolListingTemplate.js"
import SchoolDetailTemplate from "./templates/SchoolDetailTemplate.js"

function App() {
  return (
    <Router>
            <ScrollToTop /> 
      <div className="App">
        <Header /> 

        <Routes>
          {/* Homepage */}
          <Route path="/" element={<HomePage />} />

          {/* Fleet Page */}
          <Route path="/fleet" element={<FleetPage />} />

          {/* Courses Page */}
          <Route path="/courses" element={<CourseListingTemplate />} />

          {/* Schools Pages - Using Dynamic Templates */}
          <Route path="/schools" element={<SchoolListingTemplate />} />
          <Route path="/schools/:schoolSlug" element={<SchoolDetailTemplate />} />

          {/* Contact Page */}
        
          <Route path="/our-story" element={<Aboutus />} />

          <Route path="/why-wayforsky" element={<WhyUs />} />
          
          {/* Course Pages - Using Dynamic Template */}
          <Route path="/zero-to-hero" element={<CourseTemplate />} />
          <Route path="/commercial-pilot-license" element={<CourseTemplate />} />

          {/* Other Course Pages - Static for now */}
          <Route path="/private-pilot-license" element={<Privatepilot />} />
          <Route path="/flight-instructor-rating" element={<FlightInstructor />} />


          <Route path="/type-rating" element={<Typerating />} />

          <Route path="/cabin-crew" element={<Cabincrew />} />

          <Route path="/contactus" element={<ContactUs />} />

          {/* Login */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login />} />

          {/* Ground Classes - Using Dynamic Template */}
          <Route path="/dgca-classes" element={<ClassTemplate />} />
          <Route path="/elp-classes" element={<ClassTemplate />} />
          <Route path="/nios-classes" element={<ClassTemplate />} />

        {/* Webinar Page */}
        <Route path="/webinar" element={<WebinarPage />} />









          

          {/* 👇 Add this catch-all route at the very end */}
          <Route path="*" element={<NotFoundPage />} />






          {/* ADD NEW ROUTES ABOVE THIS */}
          </Routes>

        <Footer />
      </div>
    </Router>
  )
}

export default App
